import React from "react";
import { Axis } from "../../actions/crmScoring";
import { Tabs } from "@mantine/core";

interface Props {
  axis: Axis
  onChange: (axis: Axis) => void
}

// コンテンツは両タブ共通のため Tabs.List のみ使い、Tabs.Panel は使わない
// （タブの切り替えは /crm-scoring/influence ⇔ /crm-scoring/active の URL 遷移）
const AxisTabs: React.FC<Props> = ({ axis, onChange }) => (
  <Tabs
    value={axis}
    onChange={(v) => v && onChange(v as Axis)}
    mt={40}
  >
    <Tabs.List>
      <Tabs.Tab value="f2_m2" style={{ color: axis === 'f2_m2' ? 'var(--mantine-color-invy-6)' : undefined }}>
        インフルエンス分析（F2×M2）
      </Tabs.Tab>
      <Tabs.Tab value="r2_f2" style={{ color: axis === 'r2_f2' ? 'var(--mantine-color-invy-6)' : undefined }}>
        アクティブ度分析（R2×F2）
      </Tabs.Tab>
    </Tabs.List>
  </Tabs>
)

export default AxisTabs
